// extracted by mini-css-extract-plugin
export default {"root":"ColumnSelectModal_root__lHT5d","content":"ColumnSelectModal_content__kSWyF"};